var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.editable && !_vm.disabled && _vm.param.sopMocId,
              expression: "editable&&!disabled&&param.sopMocId",
            },
          ],
          staticClass: "col float-right",
        },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _c("c-btn", {
                attrs: {
                  isSubmit: _vm.isComplete,
                  url: _vm.completeUrl,
                  param: _vm.moc,
                  mappingType: "PUT",
                  label: "완료",
                  icon: "check",
                },
                on: {
                  beforeAction: _vm.completeMoc,
                  btnCallback: _vm.completeMocCallback,
                },
              }),
              _c("c-btn", {
                attrs: { label: "삭제", icon: "remove" },
                on: { btnClicked: _vm.removeMoc },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-tab", {
        attrs: {
          type: "vertical",
          tabItems: _vm.tabItems,
          height: _vm.tabHeight,
        },
        on: {
          "update:height": function ($event) {
            _vm.tabHeight = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: { moc: _vm.moc, disabled: _vm.disabled },
                  on: {
                    "update:moc": function ($event) {
                      _vm.moc = $event
                    },
                    "update:disabled": function ($event) {
                      _vm.disabled = $event
                    },
                    saveCallback: _vm.saveCallback,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }